import { Fade, LinearProgress, Slide } from '@mui/material';
import React, { useEffect } from 'react';
import Modal from '../../../Components/Modal/Modal';
import { Button, Input } from '../../../Components/StyledComponents';
import ReactDragListView from 'react-drag-listview';
import './StaffCall.scss';
import axios from 'axios';
import { alertRef } from '../../../App';
import CreateStaffCall from './CreateStaffCall';
import ModifyStaffCall from './ModifyStaffCall';

const StaffCall = () => {
    const [isDrag, setIsDrag] = React.useState(false)
    const [list, setList] = React.useState([])
    const [data, setData] = React.useState({})
    const [isLoading, setIsLoading] = React.useState(true)

    const modalRef = React.useRef(null);
    const modalModRef = React.useRef(null);

    useEffect(() => {
        getStaffCall();
    }, [])

    //API_
    const getStaffCall = () => {
        setIsLoading(true)
        axios.get('/api/table/order/call')
            .then((data) => {
                setList(data.data)
                setIsLoading(false)
            })
            .catch((e) => {
                setIsLoading(false)
            })
    }

    //직원호출 추가 함수. val : 추가 값
    const createStaffCall = (val) => {
        axios.post('/api/table/order/call', val)
            .then((data) => {
                if (data.status === 204) {
                    getStaffCall()
                    modalRef.current.closeModal();
                    alertRef.current.showAlert({ title: '직원호출이 생성 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }
    //수정
    const modifyStaffCall = (id, val) => {
        axios.patch('/api/table/order/call/'+id, val)
            .then((data) => {
                if (data.status === 204) {
                    getStaffCall()
                    modalModRef.current.closeModal();
                    alertRef.current.showAlert({ title: '직원호출이 수정 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const removeStaffCall = (id) => {
        axios.delete('/api/table/order/call/' + id)
            .then((data) => {
                if (data.status === 204) {
                    getStaffCall()
                    modalModRef.current.closeModal();
                    alertRef.current.showAlert({ title: '직원호출이 삭제 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const patchStaffCallOrder = () => {
        let arr = [];
        for (let i = 0; i < list.length; i++) {
            arr.push(list[i]._id.$oid)
        }

        axios.patch('/api/table/order/call/re_order', {
            CallIds: arr
        })
            .then((data) => {
                if (data.status === 204) {
                    getStaffCall()
                    modalModRef.current.closeModal();
                    setIsDrag(false)
                    alertRef.current.showAlert({ title: '직원호출 순서가 변경 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const dragProps = {
        onDragEnd(fromIndex, toIndex) {
            if (!isDrag) return;
            const data = [...list];
            const item = data.splice(fromIndex, 1)[0];
            data.splice(toIndex, 0, item);
            setList([...data]);
        },
        nodeSelector: 'li',
        handleSelector: 'div',
        lineClassName: 'line',
    };

    return (
        <div className='menu-group-info'>
            <div className='header-row'>
                <div/>
                <div className='row'>
                    <Button variant="sub" small style={{ marginRight: 8, width: 112 }} onClick={() => setIsDrag(old => !old)}>
                        {isDrag ? '취소' : '순서변경'}
                    </Button>

                    {
                        isDrag ?
                            <Button variant="main" small style={{ width: 112 }} onClick={() => patchStaffCallOrder()}>
                                순서 저장
                            </Button>
                            :
                            <Button variant="main" small style={{ width: 112 }} onClick={() => modalRef.current.openModal()}>
                                직원호출 추가
                            </Button>
                    }
                </div>
            </div>

            {
                isLoading ?
                    <LinearProgress color="error" />
                    :
                    <div className='divider'></div>
            }

            {
                isLoading ?
                    null
                    :
                    list.length > 0 ?
                        <ReactDragListView {...dragProps}>
                            <ol style={{ margin: 0, padding: 0 }}>
                                {
                                    list.map((data, i) => (
                                        <li key={i}>
                                            <div className='menu-group-box' style={isDrag ? { padding: 24 } : {}}>
                                                <div>
                                                    <div className='row'>
                                                        <Slide direction='right' in={isDrag} mountOnEnter unmountOnExit style={{ transitionDuration: '0.4s', transitionDelay: '0.2s' }}>
                                                            <p className='move-icon' style={{ width: isDrag ? 64 : 0, transition: 'all', transitionDuration: '0.2s' }}>
                                                                <div style={{cursor: 'pointer'}}>
                                                                    <img src={require('../../../aseets/icons/menu-drag.svg').default} style={{ width: 24, height: 24, pointerEvents: 'none' }} />
                                                                </div>
                                                            </p>
                                                        </Slide>
                                                        <p className='menu-name'>{data.Name.ko}</p>
                                                    </div>
                                                </div>
                                                <div className='row' style={{ alignItems: 'center', justifyContent: 'center', height: isDrag ? 0 : 'fit-content', opacity: isDrag ? 0 : 1, transition: 'all', transitionDuration: '0.5s' }}>
                                                    <button className='mod-btn' onClick={() => {setData(data); modalModRef.current.openModal()}}>
                                                        수정하기
                                                    </button>
                                                    <button className='remove-btn' onClick={() => alertRef.current.showAlert({ title: `정말 직원호출을 삭제하시겠어요?`, isConfirm: true, confirmText: '삭제', isCancel: true, cancelText: '취소', onConfirm: () => { alertRef.current.hideAlert(); removeStaffCall(data._id.$oid) } })}>
                                                        <img src={require('../../../aseets/icons/delete.svg').default} style={{ width: 24, height: 24 }} />
                                                    </button>
                                                </div>
                                            </div>
                                        </li>
                                    ))
                                }
                            </ol>
                        </ReactDragListView>
                        :
                        <div>
                            <p className='empty-list'>생성된 직원호출 목록이 없습니다.</p>
                        </div>
            }

            <Modal ref={modalRef} contentContainer={{ width: 500 }} isHeader title="직원호출 추가">
                <CreateStaffCall CreateStaffCall={createStaffCall} />
            </Modal>

            <Modal ref={modalModRef} contentContainer={{ width: 500 }} isHeader title="직원호출 수정">
                <ModifyStaffCall modifyStaffCall={modifyStaffCall} info={data} />
            </Modal>
        </div>
    )
}

export default StaffCall;